/* ============================================================
   Meta AddToCart for the order form (2026-10-13, direct-purchase v3)

   The order form ([data-order-form] in sections/artwork-preview.liquid) is a
   native multipart POST to /cart/add with return_to=/checkout, so it skips
   the cart page and Shopify's Facebook app never reports an add-to-cart
   (Ads Manager showed none). This fires one AddToCart when that form is
   submitted, then lets the SAME native POST go ~400ms later so navigation
   doesn't cancel the pixel request.

   Lives in its own file because artwork-preview.liquid is at Shopify's 256 KB
   limit. Listens on document (bubble phase), so it runs AFTER the section's
   own submit handler: if that handler refused the submit (no photo, no valid
   size), e.defaultPrevented is already true and this does nothing.

   Best-effort: no fbq on the page means the original submit runs untouched.
   form.submit() does not fire 'submit' again. A second tap inside the delay
   is swallowed, otherwise the piece would be added twice.
   ============================================================ */
(function () {
  // A photo OR "I'll send my photo later", never both (2026-10-14). The pipeline uses the photo and would ignore the
  // box, so a vehicle with a photo must not carry "Photo later". The builder (product-builder.js) hides the box
  // once a photo is in; the old form's vehicles get the same rule here.
  function vehicleOf(el) {
    return el.closest('.apv-vehicle') || el.closest('[data-upload]') && el.closest('[data-upload]').parentElement;
  }
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-order-form] input[type="file"]')) return;
    if (!inp.files || !inp.files.length) return;
    var v = vehicleOf(inp);
    var box = v && v.querySelector('[data-photo-later]');
    if (box && box.checked) box.checked = false;
  });
  function dropLaterWhereThereIsAPhoto(form) {
    var boxes = form.querySelectorAll('[data-photo-later]:checked, [data-pb-later]:checked');
    for (var i = 0; i < boxes.length; i++) {
      var v = boxes[i].closest('.apv-vehicle') || form;
      var files = v.querySelectorAll('input[type="file"]');
      for (var j = 0; j < files.length; j++) {
        if (files[j].files && files[j].files.length) {
          boxes[i].checked = false;
          break;
        }
      }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-order-form]')) return;
    if (!e.defaultPrevented) dropLaterWhereThereIsAPhoto(form);
    if (form.__atcSent) {
      e.preventDefault();
      return;
    }
    if (e.defaultPrevented || typeof window.fbq !== 'function') return;

    // The order card's total ("$239"); every vehicle's piece is in it.
    var value = 0;
    var totalEl = form.querySelector('[data-total]');
    if (totalEl) value = parseFloat((totalEl.textContent || '').replace(/[^0-9.]/g, '')) || 0;
    var ids = Array.prototype.map.call(form.querySelectorAll('input[name$="[id]"]:not(:disabled)'), function (i) {
      return i.value;
    });

    e.preventDefault();
    form.__atcSent = true;
    try {
      // Same shape as Shopify's own Meta app sends (its web pixel, 2026-10-14): the PRODUCT id as a product_group,
      // the variant(s) in contents. That is how the app's catalog is keyed, so the event matches a catalog item.
      // Plain variant ids as 'product' (what this sent before) are counted against the catalog match rate.
      var pid =
        form.getAttribute('data-product-id') ||
        (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id);
      var data = {
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        content_ids: pid ? [String(pid)] : ids,
        content_type: pid ? 'product_group' : 'product',
        contents: ids.map(function (id) {
          return { id: String(id), quantity: 1 };
        }),
        num_items: ids.length
      };
      if (value) data.value = value;
      window.fbq('track', 'AddToCart', data);
    } catch (err) {}
    setTimeout(function () {
      HTMLFormElement.prototype.submit.call(form);
    }, 400);
  });

  // Back from checkout restores the page from the bfcache with the flag still
  // set, which would swallow every later submit.
  window.addEventListener('pageshow', function () {
    var forms = document.querySelectorAll('[data-order-form]');
    for (var i = 0; i < forms.length; i++) forms[i].__atcSent = false;
  });
})();
